import { useNavigate } from "react-router-dom";
import useTranslate from "hooks/useTranslate";
import { useEffect, useState } from "react";
import LoyaltyContent from "components/atoms/LoyaltyContent";
import { TitleBack } from "components/atoms/TitleBack";
import { useBreakpoint } from "hooks/useBreakpoint";
import { replaceValuesInText } from "utils/replaceValuesInText";
import { useGetUserProgressLoyalty } from "queries/useGetUserProgressLoyalty";
import { LoyaltyTitle } from "components/atoms/LoyaltyTitle";
import LoyaltyListRanksContainer from "containers/organisms/LoyaltyListRanksContainer";
import { LoyaltyRankRewardsListContainer } from "containers/organisms/LoyaltyRankRewardsListContainer";
import { useLoyaltyStore } from "stores/loyalty";
import { useOffsetTop } from "./hooks";
import "./styles.sass";
import url from "../../../../url";

const LoyaltyRanks = () => {
  const { isDesktop } = useBreakpoint();
  const navigate = useNavigate();
  const t = useTranslate();
  const offsetTop = useOffsetTop();
  const [isTransparent, setIsTransparent] = useState(false);
  const indexActiveRank = useLoyaltyStore((state) => state.indexActiveRank);
  const { data: loyaltyUser } = useGetUserProgressLoyalty();
  const nameRank = loyaltyUser ? loyaltyUser.ranks[indexActiveRank].name : "";

  useEffect(() => {
    const offset = isDesktop ? 200 : 150;

    if (offsetTop < offset) {
      setIsTransparent(true);
    } else {
      setIsTransparent(false);
    }
  }, [offsetTop, isDesktop]);

  return (
    <div className="LoyaltyRanks">
      <TitleBack
        text={t("loyalty.tabs.ranks")}
        onHandleClick={() => navigate(url.routes.profile.loyaltyProgram())}
        className="LoyaltyRanks__titleBack"
      />
      <LoyaltyListRanksContainer />
      <LoyaltyContent
        isTransparent={isTransparent}
        borderBottomHeader
        headerContent={
          <LoyaltyTitle
            title={replaceValuesInText(
              t("loyalty.redesign.1.ranks.tab.title"),
              { nameRank },
            )}
            upperCase
          />
        }
      >
        <LoyaltyRankRewardsListContainer />
      </LoyaltyContent>
    </div>
  );
};

export default LoyaltyRanks;
